/**
 * @param {*} value
 * @param {string} validationValue
 * @returns {*}
 */
function regex ({ value, validationValue }) {
  if (!validationValue) return false
  const regex = new RegExp(validationValue)

  return regex.test(value)
}

module.exports = { regex }
